import React, { FC, memo, HTMLAttributes } from "react";

const TableHeaderCell: FC<HTMLAttributes<HTMLDivElement>> = ({
  children,
  ...props
}) => {
  return <div {...props}>{children}</div>;
};

export default memo(TableHeaderCell);
